import React, { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export function RouteScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useLayoutEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    return () => {
      window.history.scrollRestoration = previous;
    };
  }, [pathname, search, hash]);

  return null;
}
